import './call-to-action-button.css';
import React, { CSSProperties } from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

interface CallToActionButtonDatamodel {
  text: string;
  onClick: () => void;
  loading?: boolean;
  style?: CSSProperties;
}
const CallToActionButton: React.FC<CallToActionButtonDatamodel> = ({
  text,
  onClick,
  loading,
  style = {},
}) => {
  return (
    <div
      className={'call-to-action-button-root'}
      style={{ ...style, display: 'flex', flexDirection: 'row' }}
      onClick={onClick}
    >
      <div style={{ whiteSpace: 'nowrap' }}>{text}</div>
      {loading && (
        <div
          style={{
            marginRight: '10px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <ClipLoader loading={loading} size={16} color={'#ffffff'} />
        </div>
      )}
    </div>
  );
};

export default CallToActionButton;
